const APIv4GetProductsByCategoriesResponseAdapter = {
  toProductByCategories: v4Response => {
    const {
      response_data
    } = v4Response;
    return response_data.products.map(item => {
      const {
        price_info,
        stock
      } = item;
      return {
        categories: item.categories,
        country: item.country,
        descriptions: APIv4GetProductsByCategoriesResponseAdapter.mapDescriptions(item.descriptions),
        hiddenPrice: item.price_hide,
        id: item.productID,
        imageUrl: item.image,
        price: {
          country: price_info.country,
          currency: price_info.currency,
          currencies: Object.keys(price_info.currencies).map(k => ({
            currency: k,
            prices: price_info.currencies[k].prices.map(p => ({
              volume: p.volume,
              volumePrice: p.volume_price,
              recommendedPrice: p.recommended_price,
              unitCost: p.unit_cost,
              licence: p.licence,
              price: p.price,
              oldPrice: p.crossed_price ?? 0
            }))
          })),
          includesTaxes: price_info.tax_included,
          prices: price_info.prices,
          taxType: price_info.tax_type
        },
        gallery: APIv4GetProductsByCategoriesResponseAdapter.mapGallery(item),
        state: item.state,
        stock: {
          lowStockAlert: parseInt(stock.low_stock_alert),
          policy: stock.policy,
          stock: parseInt(stock.stock)
        },
        type: item.type,
        relatedProducts: APIv4GetProductsByCategoriesResponseAdapter.mapRelatedProducts(item.upselling, 'crosssell'),
        recommendedProducts: APIv4GetProductsByCategoriesResponseAdapter.mapRelatedProducts(item.upselling, 'upsell')
      };
    });
  },
  mapGallery: v4Product => {
    const gallery = [];
    if (v4Product.image) {
      gallery.push({
        name: '',
        nameAlt: '',
        type: 'file',
        url: v4Product.image,
        visible: true
      });
    }
    if (v4Product.previews_primary && v4Product.previews_primary.length > 0) {
      const mappedPrimaryPreviews = v4Product.previews_primary.map(media => ({
        name: media.name || '',
        nameAlt: media.alt_name || '',
        type: media.type,
        url: media.url || media.filename,
        visible: Boolean(media.visible) || true
      }));
      gallery.push(...mappedPrimaryPreviews);
    }
    if (v4Product.previews && v4Product.previews.length > 0) {
      const mappedPreviews = v4Product.previews.map(media => ({
        name: media.name || '',
        nameAlt: media.alt_name || '',
        type: media.type,
        url: media.url || media.filename,
        visible: Boolean(media.visible) || true
      }));
      gallery.push(...mappedPreviews);
    }
    return gallery;
  },
  mapDescriptions: productDescriptions => {
    return productDescriptions.map(description => ({
      lang: description.lang,
      title: description.title,
      short: description.short,
      long: description.long,
      seo: description.seo,
      sections: APIv4GetProductsByCategoriesResponseAdapter.mapDescriptionSections(description)
    }));
  },
  mapDescriptionSections: productDescription => {
    const sections = [];
    sections.push({
      i18nTitleTag: 'PRODUCTS.DESCRIPTION',
      content: productDescription.long
    });
    if (productDescription.features !== undefined) {
      sections.push({
        i18nTitleTag: 'PRODUCTS.FEATURES',
        content: productDescription.features
      });
    }
    if (productDescription.custom_tabs !== undefined) {
      sections.push(...productDescription.custom_tabs.filter(tab => tab.content).map(tab => ({
        title: tab.title,
        content: tab.content
      })));
    }
    if (productDescription.extra_descriptions !== undefined) {
      sections.push(...productDescription.extra_descriptions.filter(description => description.extra_content && Array.isArray(description.extra_content)).map(description => ({
        title: description.extra_name,
        content: description.extra_content.map(item => item.content).join('<br>')
      })));
    }
    return sections.filter(section => section.content);
  },
  mapRelatedProducts: (relations, relationType) => {
    if (!relations || !relations[relationType]) {
      return undefined;
    }
    const typeMap = {
      related_feeds: "FEED_LIST" /* RelatedProductReferenceType.FEED_LIST */,
      related_oids: "PRODUCT_LIST" /* RelatedProductReferenceType.PRODUCT_LIST */,
      related_refids: "REFERENCE_LIST" /* RelatedProductReferenceType.REFERENCE_LIST */
    };
    const [key, value] = Object.entries(relations[relationType])[0];
    return {
      type: typeMap[key],
      references: value.split('/')
    };
  },
  toProduct: response => {
    const {
      response_data
    } = response;
    return APIv4GetProductsByCategoriesResponseAdapter.toProductByCategories(response_data);
  }
};
export default APIv4GetProductsByCategoriesResponseAdapter;
